var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#26890d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 133",
    d: "M27.207.386A1.227 1.227 0 0 0 26.329 0H6.634A6.63 6.63 0 0 0 0 6.558v36.884A6.63 6.63 0 0 0 6.634 50h26.732A6.63 6.63 0 0 0 40 43.442V14.154a1.293 1.293 0 0 0-.354-.845Zm.354 3.877 8.329 8.659h-5.414a2.89 2.89 0 0 1-2.915-2.874Zm5.8 43.321H6.634a4.2 4.2 0 0 1-4.2-4.143V6.558a4.2 4.2 0 0 1 4.2-4.142h18.488v7.633a5.31 5.31 0 0 0 5.354 5.29h7.085v28.1a4.2 4.2 0 0 1-4.195 4.146Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "M30.087 39.245H9.916a1.212 1.212 0 1 0 0 2.423h20.186a1.212 1.212 0 1 0-.012-2.423Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 135",
    d: "M19.116 34.942a1.2 1.2 0 0 0 1.769 0l7.1-7.621a1.209 1.209 0 1 0-1.769-1.648l-5 5.368V17.81a1.212 1.212 0 0 0-2.423 0v13.231l-4.992-5.368a1.209 1.209 0 0 0-1.769 1.648Zm0 0"
  }))));
};
export default SvgDownload;